import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { defineAsyncComponent, ref } from "vue";
import Feedback from "@/components/shared/feedback/Feedback.vue";
import SupportModal from "@/components/modals/SupportModal.vue";
import { coApplicantRoutes } from "@/config/constants";

export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationStepRefi',
  props: {
  route: { type: String, required: true },
  application: { type: Object, required: true },
  path: { type: String, required: true },
  loading: { type: Boolean, required: true },
  previousLoading: { type: Boolean, required: true },
  isCurrent: { type: Boolean, required: true },
},
  emits: ["previous", "complete"],
  setup(__props, { emit: __emit }) {

const ChoosePath = defineAsyncComponent(() => import("../application/ChoosePath.vue"));
const RefiSchoolInfo = defineAsyncComponent(() => import("../application/RefiSchoolInfo.vue"));
const PersonalInfoPartOne = defineAsyncComponent(() => import("../application/PersonalInfoPartOne.vue"));
const RefiPersonalInfoPartTwo = defineAsyncComponent(() => import("../application/RefiPersonalInfoPartTwo.vue"));
const IsPresentInfoPartOne = defineAsyncComponent(() => import("../application/IsPresentInfoPartOne.vue"));
const RefiIsPresentInfoPartTwo = defineAsyncComponent(() => import("../application/RefiIsPresentInfoPartTwo.vue"));
const RefiConsent = defineAsyncComponent(() => import("../application/RefiConsent.vue"));
const RefiRegistration = defineAsyncComponent(() => import("../application/RefiRegistration.vue"));
const MaritalStatus = defineAsyncComponent(() => import("../application/MaritalStatus.vue"));
const RefiApproval = defineAsyncComponent(() => import("../application/Approval.vue"));
const RefiAdditionalInfo = defineAsyncComponent(() => import("../application/RefiAdditionalInfo.vue"));
const InvitedApplicant = defineAsyncComponent(() => import("../application/InvitedApplicant.vue"));
const InvitedApplicantInfoPartOne = defineAsyncComponent(
  () => import("../application/InvitedApplicantInfoPartOne.vue"),
);
const RefiInvitedApplicantInfoPartTwo = defineAsyncComponent(
  () => import("../application/RefiInvitedApplicantInfoPartTwo.vue"),
);
const RefiAddCosigner = defineAsyncComponent(() => import("../application/RefiAddCosigner.vue"));
const RefiLoanConfiguration = defineAsyncComponent(() => import("../application/RefiLoanConfiguration.vue"));
const RefiShowMyRates = defineAsyncComponent(() => import("../application/RefiShowMyRates.vue"));
const RefiShowMyRatesExit = defineAsyncComponent(() => import("../application/RefiShowMyRatesExit.vue"));
const RefiUnderlyingLoansToRefinance = defineAsyncComponent(
  () => import("../show-my-rates/RefiUnderlyingLoansToRefinance.vue"),
);
const RefiAddNewCosigner = defineAsyncComponent(() => import("../application/RefiAddNewCosigner.vue"));

const props = __props;

const emit = __emit;
const showSupportModal = ref<boolean>(false);
const coApplicant = ref<string>("Co-Applicant");
const primaryApplicant = ref<string>("Primary Applicant");
const primaryApplicantDisplayName = ref<string>("Borrower");
const coApplicantDisplayName = ref<string>("Cosigner");

function className(route: string) {
  return coApplicantRoutes.includes(props.route) === true ? `${route} co-borrower` : `${route}`;
}
// functions that mutate state and trigger updates
function previous(event: any) {
  emit("previous", event);
}
function complete(event: any) {
  emit("complete", event);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["application-step", className])
  }, [
    (__props.route === 'refiChooseBorrowerCoSigner')
      ? (_openBlock(), _createBlock(_unref(ChoosePath), {
          key: 0,
          loading: __props.loading,
          "is-current": __props.isCurrent,
          onComplete: complete
        }, null, 8, ["loading", "is-current"]))
      : (__props.route === 'refiSchoolInformation')
        ? (_openBlock(), _createBlock(_unref(RefiSchoolInfo), {
            key: 1,
            loading: __props.loading,
            "previous-loading": __props.previousLoading,
            "is-current": __props.isCurrent,
            onPrevious: previous,
            onComplete: complete
          }, null, 8, ["loading", "previous-loading", "is-current"]))
        : (__props.route === 'refiBorrowerPersonalInfo')
          ? (_openBlock(), _createBlock(_unref(PersonalInfoPartOne), {
              key: 2,
              loading: __props.loading,
              "previous-loading": __props.previousLoading,
              "is-current": __props.isCurrent,
              "applicant-type": primaryApplicant.value,
              "applicant-type-display-name": primaryApplicantDisplayName.value,
              onPrevious: previous,
              onComplete: complete
            }, null, 8, ["loading", "previous-loading", "is-current", "applicant-type", "applicant-type-display-name"]))
          : (__props.route === 'refiBorrowerPersonalInfoContinued')
            ? (_openBlock(), _createBlock(_unref(RefiPersonalInfoPartTwo), {
                key: 3,
                loading: __props.loading,
                "previous-loading": __props.previousLoading,
                "is-current": __props.isCurrent,
                "applicant-type": primaryApplicant.value,
                "applicant-type-display-name": primaryApplicantDisplayName.value,
                onPrevious: previous,
                onComplete: complete
              }, null, 8, ["loading", "previous-loading", "is-current", "applicant-type", "applicant-type-display-name"]))
            : (__props.route === 'refiCosignerPersonalInfo')
              ? (_openBlock(), _createBlock(_unref(PersonalInfoPartOne), {
                  key: 4,
                  loading: __props.loading,
                  "previous-loading": __props.previousLoading,
                  "is-current": __props.isCurrent,
                  "applicant-type": coApplicant.value,
                  "applicant-type-display-name": coApplicantDisplayName.value,
                  onPrevious: previous,
                  onComplete: complete
                }, null, 8, ["loading", "previous-loading", "is-current", "applicant-type", "applicant-type-display-name"]))
              : (__props.route === 'refiCosignerPersonalInfoContinued')
                ? (_openBlock(), _createBlock(_unref(RefiPersonalInfoPartTwo), {
                    key: 5,
                    loading: __props.loading,
                    "previous-loading": __props.previousLoading,
                    "is-current": __props.isCurrent,
                    "applicant-type": coApplicant.value,
                    "applicant-type-display-name": coApplicantDisplayName.value,
                    onPrevious: previous,
                    onComplete: complete
                  }, null, 8, ["loading", "previous-loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                : (__props.route === 'refiShowMyRates')
                  ? (_openBlock(), _createBlock(_unref(RefiShowMyRates), {
                      key: 6,
                      loading: __props.loading,
                      "previous-loading": __props.previousLoading,
                      "is-current": __props.isCurrent,
                      onPrevious: previous,
                      onComplete: complete
                    }, null, 8, ["loading", "previous-loading", "is-current"]))
                  : (__props.route === 'refiShowMyRatesExit')
                    ? (_openBlock(), _createBlock(_unref(RefiShowMyRatesExit), { key: 7 }))
                    : (__props.route === 'refiCosignerRegistration')
                      ? (_openBlock(), _createBlock(_unref(RefiRegistration), {
                          key: 8,
                          loading: __props.loading,
                          "previous-loading": __props.previousLoading,
                          "is-current": __props.isCurrent,
                          "applicant-type": coApplicant.value,
                          "applicant-type-display-name": coApplicantDisplayName.value,
                          onPrevious: previous,
                          onComplete: complete
                        }, null, 8, ["loading", "previous-loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                      : (__props.route === 'refiBorrowerAdditionalInfo')
                        ? (_openBlock(), _createBlock(_unref(RefiAdditionalInfo), {
                            key: 9,
                            loading: __props.loading,
                            "previous-loading": __props.previousLoading,
                            "is-current": __props.isCurrent,
                            "applicant-type": primaryApplicant.value,
                            "applicant-type-display-name": primaryApplicantDisplayName.value,
                            path: __props.path,
                            onPrevious: previous,
                            onComplete: complete
                          }, null, 8, ["loading", "previous-loading", "is-current", "applicant-type", "applicant-type-display-name", "path"]))
                        : (__props.route === 'refiCosignerAdditionalInfo')
                          ? (_openBlock(), _createBlock(_unref(RefiAdditionalInfo), {
                              key: 10,
                              loading: __props.loading,
                              "previous-loading": __props.previousLoading,
                              "is-current": __props.isCurrent,
                              "applicant-type": coApplicant.value,
                              "applicant-type-display-name": coApplicantDisplayName.value,
                              path: __props.path,
                              onPrevious: previous,
                              onComplete: complete
                            }, null, 8, ["loading", "previous-loading", "is-current", "applicant-type", "applicant-type-display-name", "path"]))
                          : (__props.route === 'refiCosignerHardPullConsent')
                            ? (_openBlock(), _createBlock(_unref(RefiConsent), {
                                key: 11,
                                loading: __props.loading,
                                "previous-loading": __props.previousLoading,
                                "is-current": __props.isCurrent,
                                "applicant-type": coApplicant.value,
                                "applicant-type-display-name": coApplicantDisplayName.value,
                                onPrevious: previous,
                                onComplete: complete
                              }, null, 8, ["loading", "previous-loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                            : (__props.route === 'refiBorrowerInfo')
                              ? (_openBlock(), _createBlock(_unref(IsPresentInfoPartOne), {
                                  key: 12,
                                  loading: __props.loading,
                                  "previous-loading": __props.previousLoading,
                                  "is-current": __props.isCurrent,
                                  "applicant-type": primaryApplicant.value,
                                  "applicant-type-display-name": primaryApplicantDisplayName.value,
                                  onPrevious: previous,
                                  onComplete: complete
                                }, null, 8, ["loading", "previous-loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                              : (__props.route === 'refiBorrowerInfoContinued')
                                ? (_openBlock(), _createBlock(_unref(RefiIsPresentInfoPartTwo), {
                                    key: 13,
                                    loading: __props.loading,
                                    "previous-loading": __props.previousLoading,
                                    "is-current": __props.isCurrent,
                                    "applicant-type": primaryApplicant.value,
                                    "applicant-type-display-name": primaryApplicantDisplayName.value,
                                    onPrevious: previous,
                                    onComplete: complete
                                  }, null, 8, ["loading", "previous-loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                                : (__props.route === 'refiAddCosigner')
                                  ? (_openBlock(), _createBlock(_unref(RefiAddCosigner), {
                                      key: 14,
                                      loading: __props.loading,
                                      "previous-loading": __props.previousLoading,
                                      "is-current": __props.isCurrent,
                                      onPrevious: previous,
                                      onComplete: complete
                                    }, null, 8, ["loading", "previous-loading", "is-current"]))
                                  : (__props.route === 'refiAddNewCosigner')
                                    ? (_openBlock(), _createBlock(_unref(RefiAddNewCosigner), {
                                        key: 15,
                                        loading: __props.loading,
                                        "previous-loading": __props.previousLoading,
                                        "is-current": __props.isCurrent,
                                        onPrevious: previous,
                                        onComplete: complete
                                      }, null, 8, ["loading", "previous-loading", "is-current"]))
                                    : (__props.route === 'refiCosignerInfo')
                                      ? (_openBlock(), _createBlock(_unref(IsPresentInfoPartOne), {
                                          key: 16,
                                          loading: __props.loading,
                                          "previous-loading": __props.previousLoading,
                                          "is-current": __props.isCurrent,
                                          "applicant-type": coApplicant.value,
                                          "applicant-type-display-name": coApplicantDisplayName.value,
                                          onPrevious: previous,
                                          onComplete: complete
                                        }, null, 8, ["loading", "previous-loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                                      : (__props.route === 'refiCosignerInfoContinued')
                                        ? (_openBlock(), _createBlock(_unref(RefiIsPresentInfoPartTwo), {
                                            key: 17,
                                            loading: __props.loading,
                                            "previous-loading": __props.previousLoading,
                                            "is-current": __props.isCurrent,
                                            "applicant-type": coApplicant.value,
                                            "applicant-type-display-name": coApplicantDisplayName.value,
                                            onPrevious: previous,
                                            onComplete: complete
                                          }, null, 8, ["loading", "previous-loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                                        : (__props.route === 'refiBorrowerRegistration')
                                          ? (_openBlock(), _createBlock(_unref(RefiRegistration), {
                                              key: 18,
                                              loading: __props.loading,
                                              "previous-loading": __props.previousLoading,
                                              "is-current": __props.isCurrent,
                                              "applicant-type": primaryApplicant.value,
                                              "applicant-type-display-name": primaryApplicantDisplayName.value,
                                              onPrevious: previous,
                                              onComplete: complete
                                            }, null, 8, ["loading", "previous-loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                                          : (__props.route === 'refiBorrowerHardPullConsent')
                                            ? (_openBlock(), _createBlock(_unref(RefiConsent), {
                                                key: 19,
                                                loading: __props.loading,
                                                "previous-loading": __props.previousLoading,
                                                "is-current": __props.isCurrent,
                                                "applicant-type": primaryApplicant.value,
                                                "applicant-type-display-name": primaryApplicantDisplayName.value,
                                                onPrevious: previous,
                                                onComplete: complete
                                              }, null, 8, ["loading", "previous-loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                                            : (__props.route === 'refiApproval')
                                              ? (_openBlock(), _createBlock(_unref(RefiApproval), {
                                                  key: 20,
                                                  loading: __props.loading,
                                                  "is-current": __props.isCurrent,
                                                  onComplete: complete
                                                }, null, 8, ["loading", "is-current"]))
                                              : (__props.route === 'refiLoanConfiguration')
                                                ? (_openBlock(), _createBlock(_unref(RefiLoanConfiguration), {
                                                    key: 21,
                                                    loading: __props.loading,
                                                    "previous-loading": __props.previousLoading,
                                                    "is-current": __props.isCurrent,
                                                    onPrevious: previous,
                                                    onComplete: complete
                                                  }, null, 8, ["loading", "previous-loading", "is-current"]))
                                                : (__props.route === 'refiCosignerMaritalStatus')
                                                  ? (_openBlock(), _createBlock(_unref(MaritalStatus), {
                                                      key: 22,
                                                      loading: __props.loading,
                                                      "is-current": __props.isCurrent,
                                                      "applicant-type": coApplicant.value,
                                                      "applicant-type-display-name": coApplicantDisplayName.value,
                                                      onPrevious: previous,
                                                      onComplete: complete
                                                    }, null, 8, ["loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                                                  : (__props.route === 'refiBorrowerMaritalStatus')
                                                    ? (_openBlock(), _createBlock(_unref(MaritalStatus), {
                                                        key: 23,
                                                        loading: __props.loading,
                                                        "is-current": __props.isCurrent,
                                                        "applicant-type": primaryApplicant.value,
                                                        "applicant-type-display-name": primaryApplicantDisplayName.value,
                                                        onPrevious: previous,
                                                        onComplete: complete
                                                      }, null, 8, ["loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                                                    : (__props.route === 'refiBorrowerInvited')
                                                      ? (_openBlock(), _createBlock(_unref(InvitedApplicant), {
                                                          key: 24,
                                                          loading: __props.loading,
                                                          "is-current": __props.isCurrent,
                                                          "applicant-type": primaryApplicant.value,
                                                          "applicant-type-display-name": primaryApplicantDisplayName.value,
                                                          onPrevious: previous,
                                                          onComplete: complete
                                                        }, null, 8, ["loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                                                      : (__props.route === 'refiCosignerInvited')
                                                        ? (_openBlock(), _createBlock(_unref(InvitedApplicant), {
                                                            key: 25,
                                                            loading: __props.loading,
                                                            "is-current": __props.isCurrent,
                                                            "applicant-type": coApplicant.value,
                                                            "applicant-type-display-name": coApplicantDisplayName.value,
                                                            onPrevious: previous,
                                                            onComplete: complete
                                                          }, null, 8, ["loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                                                        : (__props.route === 'refiBorrowerInvitedApplicantInfo')
                                                          ? (_openBlock(), _createBlock(_unref(InvitedApplicantInfoPartOne), {
                                                              key: 26,
                                                              loading: __props.loading,
                                                              "is-current": __props.isCurrent,
                                                              "applicant-type": primaryApplicant.value,
                                                              "applicant-type-display-name": primaryApplicantDisplayName.value,
                                                              onPrevious: previous,
                                                              onComplete: complete
                                                            }, null, 8, ["loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                                                          : (__props.route === 'refiBorrowerInvitedApplicantInfoContinued')
                                                            ? (_openBlock(), _createBlock(_unref(RefiInvitedApplicantInfoPartTwo), {
                                                                key: 27,
                                                                loading: __props.loading,
                                                                "is-current": __props.isCurrent,
                                                                "applicant-type": primaryApplicant.value,
                                                                "applicant-type-display-name": primaryApplicantDisplayName.value,
                                                                onPrevious: previous,
                                                                onComplete: complete
                                                              }, null, 8, ["loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                                                            : (__props.route === 'refiCosignerInvitedApplicantInfo')
                                                              ? (_openBlock(), _createBlock(_unref(InvitedApplicantInfoPartOne), {
                                                                  key: 28,
                                                                  loading: __props.loading,
                                                                  "is-current": __props.isCurrent,
                                                                  "applicant-type": coApplicant.value,
                                                                  "applicant-type-display-name": coApplicantDisplayName.value,
                                                                  onPrevious: previous,
                                                                  onComplete: complete
                                                                }, null, 8, ["loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                                                              : (__props.route === 'refiCosignerInvitedApplicantInfoContinued')
                                                                ? (_openBlock(), _createBlock(_unref(RefiInvitedApplicantInfoPartTwo), {
                                                                    key: 29,
                                                                    loading: __props.loading,
                                                                    "is-current": __props.isCurrent,
                                                                    "applicant-type": coApplicant.value,
                                                                    "applicant-type-display-name": coApplicantDisplayName.value,
                                                                    onPrevious: previous,
                                                                    onComplete: complete
                                                                  }, null, 8, ["loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                                                                : (__props.route === 'refiBorrowerUnderlyingLoansToRefinance')
                                                                  ? (_openBlock(), _createBlock(_unref(RefiUnderlyingLoansToRefinance), {
                                                                      key: 30,
                                                                      "previous-loading": __props.previousLoading,
                                                                      loading: __props.loading,
                                                                      "is-current": __props.isCurrent,
                                                                      "applicant-type": primaryApplicant.value,
                                                                      "applicant-type-display-name": primaryApplicantDisplayName.value,
                                                                      onPrevious: previous,
                                                                      onComplete: complete
                                                                    }, null, 8, ["previous-loading", "loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                                                                  : (__props.route === 'refiCosignerUnderlyingLoansToRefinance')
                                                                    ? (_openBlock(), _createBlock(_unref(RefiUnderlyingLoansToRefinance), {
                                                                        key: 31,
                                                                        loading: __props.loading,
                                                                        "is-current": __props.isCurrent,
                                                                        "applicant-type": coApplicant.value,
                                                                        "applicant-type-display-name": coApplicantDisplayName.value,
                                                                        onPrevious: previous,
                                                                        onComplete: complete
                                                                      }, null, 8, ["loading", "is-current", "applicant-type", "applicant-type-display-name"]))
                                                                    : _renderSlot(_ctx.$slots, "default", { key: 32 }),
    _createVNode(Feedback, {
      onShowSupportModal: _cache[0] || (_cache[0] = ($event: any) => (showSupportModal.value = true))
    }),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (showSupportModal.value)
          ? (_openBlock(), _createBlock(SupportModal, {
              key: 0,
              id: "supportModal",
              onClose: _cache[1] || (_cache[1] = ($event: any) => (showSupportModal.value = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})